import { render, staticRenderFns } from "./Power.vue?vue&type=template&id=ae2b6f7c&scoped=true&"
import script from "./Power.vue?vue&type=script&lang=js&"
export * from "./Power.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2b6f7c",
  null
  
)

export default component.exports